import { httpClient } from "../../api.js";

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

export const getDeliveryOrders = async({ limit = 10, offset = 0, userId = null, courierId = null }) => {
  try {
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('offset', offset);
    
    if (userId) {
      params.append('user_id', userId);
    }

    if (courierId) {
      params.append('courier_id', courierId);
    }

    const queryString = params.toString();
    const response = await httpClient.get(`${apiUrl}/delivery-orders?${queryString}`);
    return response.data;
  } catch (e) {
    return {
      success: false,
      error: e.message,
      status: e.status,
    };
  }
};

export const getDeliveryOrder = async(orderId) => {
  try {
    const response = await httpClient.get(`${apiUrl}/delivery-orders/${orderId}`);
    return response.data;
  } catch (e) {
    return {
      success: false,
      error: e.message,
      status: e.status,
    };
  }
};

export const updateDeliveryOrder = async({ courierId, assignedAt, confirmedAt, doneAt, receivedAt, cancelledAt, createdAt, address, orderId, comment, price, deliveryPrice, userId }) => {
  try {
    const payload = {};

    if (userId) {
      payload.userId = userId;
    }
    // if value explicitly set to null - we null it
    if (assignedAt || assignedAt === null) {
      payload.assignedAt = assignedAt;
    }
    if (confirmedAt || confirmedAt === null) {
      payload.confirmedAt = confirmedAt;
    }
    if (doneAt || doneAt === null) {
      payload.doneAt = doneAt;
    }
    if (receivedAt || receivedAt === null) {
      payload.receivedAt = receivedAt;
    }
    if (cancelledAt || cancelledAt === null) {
      payload.cancelledAt = cancelledAt;
    }
    if (createdAt || createdAt === null) {
      payload.createdAt = createdAt;
    }

    payload.comment = comment;
    payload.price = price;
    payload.deliveryPrice = deliveryPrice;
    payload.courierId = courierId;
    payload.address = address;

    const response = await httpClient.patch(`${apiUrl}/delivery-orders/${orderId}`, payload, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (e) {
    return {
      success: false,
      error: e.message,
      status: e.status,
    };
  }
};

export const updateItemsDeliveryOrder = async(order) => {
  try {
    const response = await httpClient.put(`${apiUrl}/delivery-order`, {
      id: order.id,
      items: order.items
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (e) {
    return {
      success: false,
      error: e.message,
      status: e.status,
    };
  }
};

export const createDeliveryOrder = async({ items, price, deliveryPrice, comment, shopId, userId, address, cityId, operatorId }) => {
  try {
    const response = await httpClient.post(`${apiUrl}/delivery-order`, {
      items,
      price,
      deliveryPrice,
      comment,
      userId,
      shopId,
      cityId,
      address,
      operatorId
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (e) {
    return {
      success: false,
      error: e.message,
      status: e.status,
    };
  }
};

export const uploadPhotosDeliveryOrder = async(orderId, formData) => {
  try {
    const response = await httpClient.put(`${apiUrl}/delivery-order/${orderId}/photos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
      }
    });
    return response.data;
  } catch (e) {
    return {
      success: false,
      error: e.message,
      status: e.status,
    };
  }
};
